import { TODO } from "../utilities";
import { CommercialProperty } from "./commercialProperty.model";
import { Condominium } from "./condominium.model";
import { Cottage } from "./cottage.model";
import { Farm } from "./farm.model";
import { Project } from "./gen/schemas";
import { House } from "./house.model";
import { HousingCooperative } from "./housingCooperative.model";
import { Plot } from "./plot.model";

export type { CommercialProperty } from "./commercialProperty.model";
export type { Condominium } from "./condominium.model";
export type { Cottage } from "./cottage.model";
export type { Farm } from "./farm.model";
export type { House } from "./house.model";
export type { HousingCooperative } from "./housingCooperative.model";
export type { Plot } from "./plot.model";
export type { Premises } from "./premises.model";
export type { Project_Deprecated as Project_Deprecated } from "./project.model";
export type { VitecUser } from "./user.model";
export * from "./focusArea";
export * from "./area";
export * from "./assertions";
export * from "./searchProfile";

/*
 * @deprecated
 * Replace with generated types
 */
export type VitecEstateType =
  | "House"
  | "Cottage"
  | "Farm"
  | "Plot"
  | "HousingCooperative"
  | "Condominium"
  | "CommercialProperty"
  | "Project";

export type VitecError = {
  type: "NotFound";
};

export type VitecProviderType =
  | "Estate"
  | "Contact"
  | "Dual"
  | "User"
  | "Contact";

export const VitecEstateStatusId = {
  INTAKE_ATTEMPT: "1",
  INTAKE: "2",
  FOR_SALE: "3",
  SOLD: "4",
  DORMANT: "5",
  NO_ASSIGNMENT: "6",
  RETRACTED: "7",
  RESERVED: "8",
  NOT_FOR_SALE: "9",
  SOLD_REFERENCE: "10",
  UPCOMING: "11",
  ONGOING: "12",
  SOLD_OUT: "13",
  BOOKED: "14",
  RENTED: "16",
  SOLD_OUT_PROJECT: "17",
  SOLD_OUT_OBJECT: "22",
} as const;

export type VitecStatusIdType =
  (typeof VitecEstateStatusId)[keyof typeof VitecEstateStatusId];

/*
 * @deprecated
 * Replace with generated types
 */
export type Estate =
  | House
  | Cottage
  | Farm
  | Plot
  | HousingCooperative
  | Condominium
  | CommercialProperty;

// export type VitecEstateWithBrokers = {
//   id: string;
//   estate_type: VitecEstateType;
//   estate_data: Estate;
//   responsible_broker_id: string | null;
//   additional_contact_id: string | null;
//   responsible_broker?: SupabaseVitecUserType;
//   additional_contact?: SupabaseVitecUserType;
// };

// export type SupabaseVitecUserType = {
//   id: string;
//   name: string;
//   email: string;
//   phone: string;
//   title: string;
//   description: string;
//   employee_number: number;
//   rating: number;
//   rating_count: number;
//   rating_link: string;
//   avatar_id: string;
//   updated_at: Date;
//   created_at: Date;
// };

export type VitecNotificationType = {
  name: string;
  id: string;
  event: "Update" | "Delete" | "Create" | "Remove";
  type: VitecProviderType;
  subtype: VitecEstateType;
  customerId: string;
  chainId: string;
  tenantId: string;
  data?: TODO;
};

export type GetContactParams = {
  CreatedAtFrom: string;
  CreatedAtTo: string;
};

// export type SupabaseAvatarType = {
//   id: string;
//   vitec_user_id: string;
//   extension: string;
//   created_at: Date;
//   updated_at: Date;
// };

export type VitecPerson = {
  type: string;
  firstName?: string; // Optional: Person has this, DeceasedEstate/Company/Association may not
  lastName?: string; // Optional: Person has this, DeceasedEstate/Company/Association may not
  name?: string; // Optional: DeceasedEstate/Company/Association have single name field
  socialSecurityNumber: string;
  isForeignSocialSecurityNumber: boolean;
  telephone: {
    home: string;
    work: string;
    cell: string;
    other: string;
  };
  leadScore: number;
  wantsToBeMatched: string;
  matchingChangedAt: string;
  isDeceased: boolean;
  isCompanyPerson: boolean;
  gdprApprovalDate: Date;
  id: string;
  customerId: string;
  agentId: string;
  address: {
    streetAddress: string;
    zipCode: string;
    city: string;
    countryCode: string;
  };
  email: {
    emailAddress: string;
    emailAddress2: string;
  };
  advertisingEnabled: boolean;
  note: string;
  categories: {
    id: string;
    name: string;
    readOnly: boolean;
  }[];
  createdAt: Date;
  changedAt: Date;
};

export type VitecCoordinate = {
  longitud: number;
  latitud: number;
};

export type VitecDrawnArea = {
  coordinates: VitecCoordinate[];
};

export type CrmSpeculator = {
  estateId: string;
  estateType: string;
  level: "Reserved" | string;
};

export type VitecViewing = {
  id: string;
  startsAt: string;
  endsAt: string;
  showOnInternet: boolean;
  showOnIntranet: boolean;
  isDigital: boolean;
  commentary?: string;
  participantPerTimeSlot?: number;
  bookableFromInternet: boolean;
  noLaterThen?: string | null;
  bookingUrl?: string;
  timeSlots: Array<{
    id: string;
    startsAt: string;
    endsAt: string;
    participants: Array<{
      hasParticipated: boolean;
      contactId: string;
    }>;
  }>;
  estateId: string;
  isProjectViewing: boolean;
};

export type VitecWebhookBody = {
  name: string;
  relId1: string;
  relType1: string;
  relId2: string;
  relType2: string;
  event: string;
  type: string;
  subtype: string;
  customerId: string;
  chainId: string;
  tenantId: string;
};
